export const LISTED_FORMS = "SET_LISTED_FORMS";

export const setListedForms = (listedForms) => {
	return {
		type: LISTED_FORMS,
		listedForms,
	};
};
